function preloadOne(url: string) {
  return new Promise<void>((resolve) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = () => resolve()
    img.src = url
  })
}

export async function preloadRewardImages(urls: {
  full?: string
  blank?: string
}): Promise<void> {
  await Promise.all([
    urls.full ? preloadOne(urls.full) : Promise.resolve(),
    urls.blank ? preloadOne(urls.blank) : Promise.resolve(),
  ])
}
